<template>
  <div v-if="showActivity" class="activity-selector">
    <!-- 触发按钮 -->
    <div class="trigger" :class="{ active: isPanelVisible }" @click="togglePanel">
      <img src="/images/activity-selector.png" alt="精彩活动" />
      <span>精彩活动</span>
      <div class="close" @click.prevent="handleClose">关闭</div>
    </div>
    <!-- 活动面板 -->
    <Transition name="slide">
      <div v-if="isPanelVisible" class="activity-panel">
        <!-- 向上箭头 -->
        <div class="scroll-arrow up" @click="scrollList('up')">
          <i class="arrow-icon"></i>
        </div>

        <!-- 活动列表 -->
        <div class="activity-list" ref="listRef" @touchstart="touchStart" @touchmove="touchMove"
          @touchend="touchEnd">
          <div v-for="(item, index) in rightBottomIcon"
            :key="`${item.slideshow_id}${item.slideshow_code}${item.state_time}`"
            v-show="item.state == 1 && Number(item.slideshow_code) !== 60" @click="onAffixItemClick(item, 2)"
            class="activity-item">
            <template v-if="item.link === 2">
              <img class="left-avatar" :src="formatOutLinkData(item.pic_addr).url" />
              <!-- <p>
              {{ formatOutLinkData(item.pic_addr).name }}
            </p> -->
            </template>
            <template v-else>
              <img class="left-avatar not2" :src="formatOutLinkData(item.pic_addr).url" />
              <!-- <p>
              {{ item.link === 1 ? $t(item.link_name) : $t(formatOutLinkData(item.pic_addr).name) }}
            </p> -->
            </template>
          </div>
        </div>

        <!-- 向下箭头 -->
        <div class="scroll-arrow down" @click="scrollList('down')">
          <i class="arrow-icon"></i>
        </div>
      </div>
    </Transition>
  </div>
  <!--红包弹窗-->
  <RedPack ref="redPackRef" :showIcon="false" />
</template>

<script setup lang="ts">
import { ref,onMounted } from 'vue';
import {  getSession ,setSession} from "/@/kernel-mn/utils/storage";
import { useBottomSwiper } from './useBottomSwiper';
import RedPack from "/@/layout/child-page/RedPack.vue";

// 组件状态
const showActivity = ref(false)
const isPanelVisible = ref(false)
const listRef = ref<HTMLElement | null>(null)
const touchStartY = ref(0)

const { rightBottomIcon, onAffixItemClick, formatOutLinkData, redPackRef } = useBottomSwiper()

// 切换面板显示
const togglePanel = () => {
  isPanelVisible.value = !isPanelVisible.value
}
const test = ()=> console.log('test')
// 滚动控制
const scrollList = (direction: 'up' | 'down') => {
  if (!listRef.value) return

  const scrollAmount = 100
  const currentScroll = listRef.value.scrollTop
  listRef.value.scrollTo({
    top: direction === 'up' ? currentScroll - scrollAmount : currentScroll + scrollAmount,
    behavior: 'smooth'
  })
}

// 触摸事件处理
const touchStart = (e: TouchEvent) => {
  touchStartY.value = e.touches[0].clientY
}

const touchMove = (e: TouchEvent) => {
  if (!listRef.value) return

  const touchCurrentY = e.touches[0].clientY
  const deltaY = touchStartY.value - touchCurrentY
  listRef.value.scrollTop += deltaY
  touchStartY.value = touchCurrentY
}

const touchEnd = () => {
  touchStartY.value = 0
  console.log('touchEnd')
}
const handleClose = ()=>{
  showActivity.value = false
   // 首页活动刷新显示
   setSession('HOME_ACTIVITY_SHOW', '0')
}

onMounted(()=>{
   // 首页活动刷新显示
   const isShow =   getSession('HOME_ACTIVITY_SHOW')
   showActivity.value = isShow === '1'
})
</script>

<style lang="scss" scoped>
.activity-selector {
  position: fixed;
  right: px2rem(14);
  bottom: px2rem(100);
  z-index: 9999;

  .trigger {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: px2rem(12) px2rem(4) px2rem(4);
    background: rgba(255, 255, 255, 0.6);
    border-top-left-radius: px2rem(30);
    border-top-right-radius: px2rem(30);

    &.active {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    img {
      width: px2rem(52);
      height: px2rem(52);
    }

    span {
      color: #fff;
      background: linear-gradient(180deg, #4B0FF0 0%, #8E68F6 100%);
      padding: px2rem(1) px2rem(8);
      border-radius: px2rem(10);
      font-size: px2rem(10);
      position: absolute;
      bottom: 0;
      white-space: nowrap;
    }

    .close {
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      font-size: px2rem(10);
      position: absolute;
      bottom: px2rem(-16);
      padding: px2rem(1) px2rem(10);
      border-bottom-left-radius: px2rem(6);
      border-bottom-right-radius: px2rem(6);
    }
  }

  .activity-panel {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: px2rem(60);
    background: rgba(255, 255, 255, 0.6);
    border-top-left-radius: px2rem(40);
    border-top-right-radius: px2rem(40);
    overflow: hidden;
  }

  .scroll-arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    height: px2rem(24);
    cursor: pointer;
  }

  .arrow-icon {
    background: url(publicImgUrl('/activity-arrow.png')) no-repeat;
    background-size: 100% 100%;
    width: px2rem(19);
    height: px2rem(12);
  }

  .down {
    .arrow-icon {
      transform: rotate(180deg);
    }
  }

  .activity-list {
    max-height: px2rem(200);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: px2rem(20);
  }

  .activity-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: px2rem(20);
    cursor: pointer;
  }

  .activity-item:hover {
    background: #f5f5f5;
  }

  .activity-item img {
    width: px2rem(44);
    height: px2rem(44);
    border-radius: 50%;

  }

  /* 过渡动画 */
  .slide-enter-active,
  .slide-leave-active {
    transition: transform 0.3s ease;
  }

  .slide-enter-from,
  .slide-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }
}
</style>